import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiCreateLoan } from "../api/lspApi";

const defaultLoan = {
    loan_id: "7545339",
    amount: 50000,
    max_amount_applied: 50000,
    tenure: 12,
    periodicity: "monthly",
    creation_date: "2024-05-25",
    total_processing_fee: 1,
    broken_period_interest: 500,
    interest_rate: 33,
    aadhar_number: 123434565678,
    pan_number: "KHYBP3212J",
    user_phone: 1100229933,
    name: "Ankit",
    father_name: "test",
    date_of_birth: "2001-03-24",
    gender: "male",
    marital_status: "unmarried",
    education_level: "graduate",
    employer_name: "tectcom",
    date_of_joining: "2024-05-24",
    employment_type: "salaried",
    email: "someone@example.com",
    monthly_salary: 15000,
    family_members: 3,
    monthly_family_income: 40000,
    foir_score: 0.4,
    bank_account: 1233536547658754,
    ifsc_code: "JNUB1116433",
    name_alt_bank_account_holder: "",
    alternate_bank_account: "",
    alternate_ifsc_code: "",
    applicant_type: "co_borrower",
    purpose: "Medical",
    credit_profile: { bureau_name: "crif", score: 0, total_existing_obligation: 0, number_of_writtenoff_in_12_months: 0 },
    address: {
        permanent_address: "",
        permanent_address_city: "",
        permanent_address_state: "",
        permanent_address_pin: "",
        current_address: "",
        current_address_city: "",
        current_address_state: "",
        current_address_pin: "",
        current_address_owned: "",
        current_address_landmark: "",
        raw_data: "",
    }
};

export default function CreateLoanPage() {
    const { state, setPartnerLoanId } = useLsp();
    const [json, setJson] = useState(JSON.stringify(defaultLoan, null, 2));
    const [out, setOut] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut("");
        try {
            const body = JSON.parse(json);
            const res = await apiCreateLoan(state.baseUrl, state.token, body);
            if (res?.loan_id) setPartnerLoanId(res.loan_id);
            setOut(JSON.stringify(res, null, 2));
        } catch (e) {
            setOut("❌ " + e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={card}>
            <h2 style={h2}>2) Submit Loan Data (Create Loan)</h2>
            <textarea style={ta} value={json} onChange={(e) => setJson(e.target.value)} />
            <div style={{ marginTop: 10 }}>
                <button style={btn} onClick={run} disabled={loading || !state.token}>
                    Create Loan
                </button>
                <span style={{ marginLeft: 10, opacity: 0.75 }}>
                    {/* Needs Bearer token. :contentReference[oaicite:15]{index = 15} */}
                </span>
            </div>
            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}

const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const ta = { width: "100%", minHeight: 260, background: "#fffff", color: "#e5e7eb", border: "1px solid #334155", borderRadius: 10, padding: 12, fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
